import type { FC } from "react";

import { getResourceLinkTitle } from "../../chat.helpers";
import type { McpResourceLink } from "../../chat.types";
import { ArtifactRowButton } from "./artifact-row-button";

export const GenericArtifactRow: FC<{ resource: McpResourceLink }> = ({ resource }) => (
  <ArtifactRowButton resource={resource}>
    <span className="min-w-0 flex-1 truncate text-sm">{getResourceLinkTitle(resource)}</span>
  </ArtifactRowButton>
);
